import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SmsAuthSetupStepComponent } from 'app/components/v2-layout/shared/two-factor-setup-steps/sms-auth-setup-step.component';

/**
 * Settings → Security wrapper: hosts the shared {@link SmsAuthSetupStepComponent}
 * inside a dialog so SMS enrollment is identical to the 2FA gate stepper and the
 * enrollment logic lives in exactly one place. Preserves the existing open()/afterClosed
 * contract — resolves `{success: true}` once enrolled and `undefined` on cancel — so the
 * Settings tab is unchanged (SD-8102).
 */
@Component({
    selector: 'app-setup-sms-authentication',
    templateUrl: './setup-sms-authentication.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDialogModule,
        SmsAuthSetupStepComponent,
    ],
})
export class SetupSmsAuthenticationComponent
{
    constructor(private _dialogRef: MatDialogRef<SetupSmsAuthenticationComponent>) {
    }

    onCompleted(): void {
        this._dialogRef.close({success: true});
    }

    onCancelled(): void {
        this._dialogRef.close();
    }
}
